import { PrintIcon } from "assets/icons";
import { GoBackHeaderTitle } from "components";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  Button,
  DateRangeInput,
  Pagination,
  PersonSummary,
  SearchInput
} from "ui";

import { DeliveriesTable } from "../../components";
import { useDeliveriesByDriver } from "../../hooks";

import styles from "./DriverDeliveries.module.scss";

const DriverDeliveries = () => {
  const { t } = useTranslation();
  const {
    driver,
    deliveries,
    allPagesDeliveries,
    isLoading,
    dateRange,
    searchValue,
    sorting,
    page,
    totalItems,
    refetch,
    setPage,
    setSorting,
    setSearchValue,
    setDateRange
  } = useDeliveriesByDriver();

  const navigate = useNavigate();

  return (
    <ContentLayout
      title={
        <GoBackHeaderTitle
          title={t("Deliveries")}
          onGoBack={() => navigate({ pathname: "/deliveries" })}
        />
      }
    >
      <BoxShadowLayout className={styles.driverDeliveries}>
        <PersonSummary
          isLoading={isLoading}
          personId={driver?.id}
          personFullName={
            driver ? `${driver.firstname} ${driver.lastname}` : ""
          }
          personImage={driver?.image}
          statistic={[
            {
              label: t("Earned from customers"),
              value: driver?.totalAmountEarnedFromCustomers
            },
            { label: t("To collect"), value: driver?.totalAmountToCollect },
            { label: t("To pay"), value: driver?.totalAmountToPay },
            { label: t("Paid"), value: driver?.totalAmountPaid },
            { label: t("Collected"), value: driver?.totalAmountCollected }
          ]}
        />

        <div className={styles.driverDeliveries_tableHeader}>
          <SearchInput
            value={searchValue}
            onChange={setSearchValue}
            placeholder={t("Search")}
          />

          <div className={styles.driverDeliveries_tableHeader_rightBlock}>
            <DateRangeInput value={dateRange} onChange={setDateRange} />

            <Button
              className={styles.driverDeliveries_tableHeader_printBtn}
              icon={<PrintIcon />}
              onClick={() => allPagesDeliveries.mutate()}
              loading={allPagesDeliveries.isLoading}
            >
              {t("Print Report")}
            </Button>
          </div>
        </div>

        <DeliveriesTable
          items={deliveries ?? []}
          sorting={sorting}
          setSorting={setSorting}
          isLoading={isLoading}
          refetchDeliveries={refetch}
        />

        <Pagination
          currentPage={page}
          onChange={setPage}
          totalItems={totalItems}
        />
      </BoxShadowLayout>
    </ContentLayout>
  );
};

export default DriverDeliveries;
